import { Component } from '@angular/core';

@Component({
	selector: 'app-setup-wizard-view-previous-job-details',
	imports: [],
	standalone: true,
	templateUrl: './setup-wizard-view-previous-job-details.html',
	styleUrl: './setup-wizard-view-previous-job-details.scss',
})
export class SetupWizardViewPreviousJobDetails {}
